import { render } from "./TermsConditionsPage.vue?vue&type=template&id=da919916&scoped=true&ts=true"
import script from "./TermsConditionsPage.vue?vue&type=script&lang=ts"
export * from "./TermsConditionsPage.vue?vue&type=script&lang=ts"

import "./TermsConditionsPage.vue?vue&type=style&index=0&id=da919916&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da919916"]])

export default __exports__